import { Injectable } from "@angular/core";
import { BaseStorageService } from "../../core/storage/base-storage.service";
import { Equipment } from "../../models/equipment.model";

@Injectable({ providedIn: "root" })
export class EquipmentStorageService extends BaseStorageService<Equipment> {
  protected override readonly storeName = "equipment";
}
